import { currencyFormatter, getAssetURL } from "../utils";
import FSSCertificate from "../components/Certificate/fssCertificate";
import TRUCertificate from "../components/Certificate/truCertificate";

const postTagline = (loan) =>
  `I'm proud to announce my financial success has been reviewed by Sun West, a major national lender, and I have been awarded a certificate for ${currencyFormatter(
    loan?.purchasePrice
  )
    .split(".")
    .shift()}. With this, I can buy a ${currencyFormatter(loan?.purchasePrice)
    .split(".")
    .shift()} house with the same strength as a cash buyer.`;

const siteContent = {
  fss: {
    mainHeadline: "Sun West's Financial Soundness",
    productName: "Financial Soundness Status",
    pageOneText:
      "After a rigorous review and in depth financial analysis conducted by Sun West's independent credit expert, we are proud to award you this certificate of Financial Soundness.",
    pageOneImage: getAssetURL("side-one.png"),
    pageOneMobileImage: getAssetURL("mobile-sideone.png"),
    pageFourLogo:
      "https://resources.swmc.com/swmc-images/Homepage/New/SunWest41YearsofTrust-Blue.png",
    pageFourLogoTitle:
      "Financial Soundness Status by Sun West Mortgage Company, LLC",
    pageFourLogoClassName: "fss-logo",
    pageFourTermsLink: "https://www.swmc.com/terms-and-conditions",
    pageFourTermsLinkTitle: "SWMC Terms and Conditions",
    pageFourShowDateCol: false,
    certificateComponent: (captureRef, loan, handleCanvasDataURL, load) => (
      <FSSCertificate
        captureRef={captureRef}
        loan={loan}
        handleCanvasDataURL={handleCanvasDataURL}
        load={load}
      />
    ),
    facebookPostImage: getAssetURL("fss-facebook-post.png"),
    instagramPostImage: getAssetURL("fss-instagram-post.png"),
    xPostImage: getAssetURL("fss-x-post.png"),
    postDescription:
      "Secure your Financial Soundness at Sun West Mortgage Company, Inc.",
    postTagline: postTagline,
    certificateName: "Certificate of Financial Soundness",
    certificateQuality: 1,
  },
  truapproval: {
    mainHeadline: "Sun West's TRU Approval™",
    productName: "TRU Approval™",
    pageOneText:
      "After a rigorous review and in depth financial analysis conducted by Sun West's independent credit expert, we are proud to award you this Certificate of Tru Approval™.",
    pageOneImage: getAssetURL("truap-sideone.png"),
    pageOneMobileImage: getAssetURL("tru-mobile-sideone.png"),
    pageFourLogo: getAssetURL("tru-approval-badge.png"),
    pageFourLogoTitle: "TRU Approval™ by Sun West Mortgage Company, LLC",
    pageFourLogoClassName: "truapproval-logo",
    pageFourTermsLink: "https://www.swmc.com/tru-terms",
    pageFourTermsLinkTitle: "TRU Approval™ Terms and Conditions",
    pageFourShowDateCol: true,
    certificateComponent: (captureRef, loan, handleCanvasDataURL, load) => (
      <TRUCertificate
        captureRef={captureRef}
        loan={loan}
        handleCanvasDataURL={handleCanvasDataURL}
        load={load}
      />
    ),
    facebookPostImage: getAssetURL("tru-facebook-post.png"),
    instagramPostImage: getAssetURL("tru-instagram-post.png"),
    xPostImage: getAssetURL("tru-x-post.png"),
    postDescription:
      "Secure your Future with TRU Approval™ by Sun West Mortgage Company, Inc.",
    postTagline: postTagline,
    certificateName: "Certificate of TRU Approval™",
    certificateQuality: 0.5,
  },
};

const content = siteContent[process.env.REACT_APP_CERTIFICATE_NAME];

export default content;
